import React, { useState, useEffect, useContext } from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import CurrencyConverterFormat from '../../utils/CommonFunctionality/CurrencyConverter/CurrencyConverterFormat'
import FavoriteCheckbox from '../../Product/components/atoms/FavoriteCheckbox'
import PrimaryButton from '../../Product/components/atoms/PrimaryButton'
import { useHistory, useLocation } from 'react-router'
import Loaders from '../../Product/components/molecules/Loaders'
import {
    currencyFormat,
    dateFormatFrontDay,
    handleRedirectInternal,
} from '../../Product/common/components'
import Timer from '../../Product/common/timer'
import CartContext from '../../Product/context/cart/cartContext'

const RetailListView = ({
    props,
    item,
    getAllProducts,
    user,
    watchlist,
    isAuthenticated,
    type,
    handleBidModalClick,
}) => {
    const history = useHistory()
    const [bidText, setBidText] = useState('Bid Now')
    const cartContext = useContext(CartContext)
    const [active, setActive] = useState(false)
    const { addToCart, removeFromCart, buyer_cartitems } = cartContext

    const getBidText = (item) => {
        if (
            isAuthenticated &&
            (item.latestbid_user != null || item.highest_bidder_user_id != null) &&
            user?.id != undefined
        ) {
            if (item.auction) {
                if (
                    (item.latestbid_user == user?.id || item.highest_bidder_user_id == user?.id) &&
                    item.wprice >= item.rprice
                ) {
                    if (item.market_status == 'open') {
                        setBidText('Winning')
                    } else if (item.market_status == 'sold') {
                        setBidText('Won')
                    }
                } else if (
                    (item.latestbid_user != user?.id || item.highest_bidder_user_id != user?.id) &&
                    (item.currentUserBidAmount || item.bid_or_not || item.cbidnot || item.mybid)
                ) {
                    if (item.market_status == 'open') {
                        setBidText('Outbid')
                    } else if (item.market_status == 'sold') {
                        setBidText('Lost')
                    }
                } else {
                    setBidText('Bid Now')
                }
            }
        } else {
            setBidText('Bid Now')
        }
    }

    useEffect(() => {
        getBidText(item)
    }, [item.wprice, user?.id, isAuthenticated])

    useEffect(() => {
        if (buyer_cartitems.results) {
            if (item?.id) {
                let position = _.findIndex(buyer_cartitems.results, {
                    project_id: item.id,
                })
                position === -1 ? setActive(false) : setActive(true)
            }
        }
    }, [buyer_cartitems.results, item?.id])

    const handleClick = async (id) => {
        // if (props.redirect_product_view) {
        handleRedirectInternal(history, `product/${id}`)
        // } else {
        //     // setSelectedProduct(id)
        //     params.set('product', id)
        //     history.replace({
        //         pathname: location.pathname,
        //         search: params.toString(),
        //     })
        // }
    }
    const handleCart = async (id) => {
        if (global?.storeConfigration?.guest_user_login?.value) {
            if (active) {
                removeFromCart({ id })
            } else
                addToCart({
                    id: item.id,
                    qty: item.qty,
                    manufacture_date:
                        item.custom_field_9 && item.custom_field_9.includes('}')
                            ? JSON.parse(item.custom_field_9)?.inventory_date
                            : '',
                })
        } else {
            if (!user?.card_paymentid) {
                setAlert('Add a card to buy!', 'error')
                return handleRedirectInternal(history, 'dashboard/cards')
            }
            if (active) {
                removeFromCart({ id })
            } else
                addToCart({
                    id: item.id,
                    qty: item.qty,
                    manufacture_date:
                        item.custom_field_9 && item.custom_field_9.includes('}')
                            ? JSON.parse(item.custom_field_9)?.inventory_date
                            : '',
                })
        }
    }

    return (
        <div className="wonTabListInfo">
            <div className="dashListCard">
                <div className="auction-card">
                    <div className="item-icon">
                        {isAuthenticated &&
                            (bidText == 'Winning' ||
                                bidText == 'Won' ||
                                bidText == 'Outbid' ||
                                bidText == 'Lost') && (
                                <div
                                    className={`listItemAct bid-now-wrap ${
                                        isAuthenticated &&
                                        (bidText == 'Winning' || bidText == 'Won') &&
                                        'winBtnWrpr'
                                    } ${
                                        isAuthenticated &&
                                        (bidText == 'Outbid' || bidText == 'Lost') &&
                                        'outbidBtnWrpr'
                                    }`}
                                >
                                    <PrimaryButton
                                        disabled={item.market_status == 'sold'}
                                        name={item.id}
                                        label={bidText}
                                        btnColor={item.latestbid_user == user?.id && 'success'}
                                    />
                                </div>
                            )}
                        <LazyLoadImage
                            src={`${
                                item.content_head1 === '0' || item.store_id === 0
                                    ? process.env.REACT_APP_BASE_URL + 'uploads/product/'
                                    : process.env.REACT_APP_PRODUCT_IMAGE_URL
                            }${
                                global.storeConfigration?.image_compression?.value == 1
                                    ? 'thumb_'
                                    : ''
                            }${
                                (item.lotImages?.length && item.lotImages[0]?.file_name) ||
                                (item?.lotImages?.length && item?.lotImages[0]?.file_name) ||
                                item.file_name ||
                                item.avatar_vc
                            }`}
                            effect="blur"
                            placeholderSrc="/assets/svg/imageLoading.svg"
                            height="100%"
                            width="100%"
                            className="gridImage"
                            onError="/lots-images/greenField/Media.png"
                            alt={item.title}
                            onClick={() => handleClick(item.id)}
                        />
                        {!watchlist && (
                            <FavoriteCheckbox
                                watchlisted={item.watchlistid || item.watchlisted || item.isFav}
                                project_id={item.id}
                                from="card"
                                getAllProducts={getAllProducts}
                                viewProduct={props.searchResult}
                                setViewProduct={props.setViewProduct}
                                theme={props.cardTheme}
                            />
                        )}
                    </div>
                    <div className="bodyConain">
                        <div className="item-header">
                            <div className="d-flex topHdrs">
                                <span
                                    className="title"
                                    onClick={() =>
                                        history.push({
                                            pathname: `/product/${item.id}`,
                                        })
                                    }
                                    dangerouslySetInnerHTML={{
                                        __html: item.title,
                                    }}
                                ></span>
                                {!watchlist && (
                                    <div
                                        className={`${
                                            item.auctionnotes === 'new ppp'
                                                ? 'condition_new'
                                                : 'condition_openbox'
                                        } mb-2 `}
                                    >
                                        {item.auctionnotes !== '' ? item.auctionnotes : 'Like New'}
                                    </div>
                                )}
                            </div>
                            <div className="d-flex align-items-center gap-3">
                                {watchlist && (
                                    <FavoriteCheckbox
                                        watchlisted={
                                            item.watchlistid || item.watchlisted || item.isFav
                                        }
                                        project_id={item.id}
                                        from="card"
                                        getAllProducts={getAllProducts}
                                        viewProduct={props.searchResult}
                                        setViewProduct={props.setViewProduct}
                                        theme={props.cardTheme}
                                    />
                                )}

                                {watchlist ? (
                                    <div className="pickUply"> Pick Up Only</div>
                                ) : (
                                    <a href="#" className="pickup-only">
                                        Pick Up Only
                                    </a>
                                )}
                            </div>
                        </div>
                        <div className="ItemInformation">
                            <div className="item-details">
                                <div className="retail">Retail   ${item.mprice}</div>
                                <div className="price">
                                    {(item.buynow && item.bprice) ||
                                    (item.auction && item.wprice) ? (
                                        <>
                                            <h6
                                                className={`${
                                                    !item.buynow
                                                        ? 'galleryPrice homeflashbuyNow'
                                                        : 'galleryPrice homeflashbuyNow'
                                                }`}
                                            >
                                                <span>
                                                    {item.market_status === 'sold'
                                                        ? 'Sold'
                                                        : item.auction && item.wprice
                                                        ? item.nobids > 0
                                                            ? 'Current Price'
                                                            : 'Start Price'
                                                        : 'Buy Now'}{' '}
                                                </span>
                                                <span className="prcTxtVal">
                                                    {currencyFormat(
                                                        parseFloat(
                                                            item.auction && item.wprice
                                                                ? item.wprice
                                                                : item.bprice,
                                                        ).toFixed(2),
                                                        props.currencyType,
                                                    )}
                                                    <CurrencyConverterFormat amount={item.bprice} />
                                                    &#40;
                                                    <div className="offer">
                                                        {/* {
                                                                                                                    discount
                                                                                                                } */}
                                                        15 % off
                                                    </div>
                                                    &#41;
                                                </span>
                                            </h6>
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                </div>
                                <a href="#" className="qr-link">
                                    {props.auction_city || item.auction_city ? (
                                        <div
                                            className="grid-loc"
                                            onClick={() =>
                                                handleRedirectInternal(history, 'become_a_seller')
                                            }
                                        >
                                            <label>
                                                Location : {props.auction_city || item.auction_city}
                                                , TX
                                            </label>
                                        </div>
                                    ) : (
                                        ''
                                    )}
                                </a>
                                {watchlist && (
                                    <div
                                        className={`condition ${
                                            item.auctionnotes === 'New'
                                                ? 'condition_new'
                                                : item.auctionnotes === 'Used'
                                                ? 'condition_used'
                                                : item.auctionnotes === 'Damaged'
                                                ? 'condition_Damaged'
                                                : item.auctionnotes === 'test'
                                                ? 'condition_test'
                                                : item.auctionnotes === 'Open Box'
                                                ? 'condition_openbox'
                                                : item.auctionnotes === 'Open-box'
                                                ? 'condition_openbox'
                                                : item.auctionnotes === 'Open-Box'
                                                ? 'condition_openbox'
                                                : item.auctionnotes === 'Test'
                                                ? 'condition_test'
                                                : item.auctionnotes === 'Like new'
                                                ? 'condition_likenew'
                                                : item.auctionnotes === 'Not Inspected'
                                                ? 'condition_Damaged'
                                                : item.auctionnotes === 'Untested'
                                                ? 'condition_untested'
                                                : 'condition_combain'
                                        } mb-2
                                                        `}
                                    >
                                        {item.auctionnotes !== '' ? item.auctionnotes : 'Like New'}
                                    </div>
                                )}
                                {!watchlist && (
                                    <div
                                        className={`homeflashBtnGroup ${
                                            !isAuthenticated && 'noAuth'
                                        }`}
                                    >
                                        {item.auction && !item.buynow ? (
                                            <>
                                                {isAuthenticated ? (
                                                    <PrimaryButton
                                                        btnSize="homeBidBtn"
                                                        disabled={item.market_status == 'sold'}
                                                        onClick={() => handleBidModalClick(item.id)}
                                                        label="Bid Now"
                                                    />
                                                ) : (
                                                    <PrimaryButton
                                                        btnSize="homeBidBtn"
                                                        disabled={item.market_status == 'sold'}
                                                        onClick={() =>
                                                            handleRedirectInternal(history, 'login')
                                                        }
                                                        label="Login To Bid"
                                                    />
                                                )}
                                            </>
                                        ) : item.auction && item.buynow ? (
                                            <>
                                                {isAuthenticated ? (
                                                    <>
                                                        <PrimaryButton
                                                            btnSize="homeBidBtn"
                                                            disabled={item.market_status == 'sold'}
                                                            onClick={() =>
                                                                handleBidModalClick(item.id)
                                                            }
                                                            label="Bid Now"
                                                        />
                                                        <PrimaryButton
                                                            btnSize="homeBuyBtn"
                                                            disabled={item.market_status == 'sold'}
                                                            name={item.id}
                                                            onClick={() => handleCart(item.id)}
                                                            label={
                                                                window.location.pathname.includes(
                                                                    'search',
                                                                ) ||
                                                                props.type === 'Auction' ||
                                                                item.auction
                                                                    ? (props.type === 'buynow' ||
                                                                          item.buynow) &&
                                                                      (!item.auction ||
                                                                          window.location.href.includes(
                                                                              '/gallery',
                                                                          ))
                                                                        ? isAuthenticated
                                                                            ? 'Buy Now'
                                                                            : 'Login To Buy Now'
                                                                        : isAuthenticated
                                                                        ? 'Buy Now'
                                                                        : 'Login To Bid'
                                                                    : isAuthenticated
                                                                    ? 'Buy Now'
                                                                    : 'Login To Buy Now'
                                                            }
                                                            btnColor={
                                                                item.latestbid_user == user?.id &&
                                                                'success'
                                                            }
                                                        />
                                                    </>
                                                ) : (
                                                    <PrimaryButton
                                                        btnSize="homeBidBtn"
                                                        disabled={item.market_status == 'sold'}
                                                        onClick={() =>
                                                            handleRedirectInternal(history, 'login')
                                                        }
                                                        label="Login To Bid"
                                                    />
                                                )}
                                            </>
                                        ) : !item.auction && item.buynow ? (
                                            <>
                                                {isAuthenticated ? (
                                                    <>
                                                        <div className="opacity-0"></div>
                                                        <PrimaryButton
                                                            btnSize="homeBuyBtn"
                                                            disabled={item.market_status == 'sold'}
                                                            name={item.id}
                                                            onClick={() =>
                                                                handleBidModalClick(item.id)
                                                            }
                                                            label={
                                                                window.location.pathname.includes(
                                                                    'search',
                                                                ) ||
                                                                type === 'Auction' ||
                                                                item.auction
                                                                    ? (type === 'buynow' ||
                                                                          item.buynow) &&
                                                                      (!item.auction ||
                                                                          window.location.href.includes(
                                                                              '/gallery',
                                                                          ))
                                                                        ? isAuthenticated
                                                                            ? 'Buy Now'
                                                                            : 'Login To Buy Now'
                                                                        : isAuthenticated
                                                                        ? bidText
                                                                        : 'Login To Bid'
                                                                    : isAuthenticated
                                                                    ? 'Buy Now'
                                                                    : 'Login To Buy Now'
                                                            }
                                                            btnColor={
                                                                item.latestbid_user == user?.id &&
                                                                'success'
                                                            }
                                                        />
                                                    </>
                                                ) : (
                                                    <PrimaryButton
                                                        btnSize="homeBuyBtn"
                                                        disabled={item.market_status == 'sold'}
                                                        onClick={() =>
                                                            handleRedirectInternal(history, 'login')
                                                        }
                                                        label="Login To Buy"
                                                    />
                                                )}
                                            </>
                                        ) : (
                                            ''
                                        )}
                                    </div>
                                )}
                                {watchlist && (
                                    <div className="cardCount text-left">
                                        {/* {item.nobids} Bids | */}
                                        {item?.watchlist_count !== ''
                                            ? item?.watchlist_count
                                            : 0}{' '}
                                        watchers | {item?.most_viewed || 25} viewers
                                    </div>
                                )}
                            </div>
                            <div className="listTimeCotainer">
                                {!watchlist && (
                                    <div className="cardCount">
                                        {/* {item.nobids} Bids | */}
                                        {item?.watchlist_count !== ''
                                            ? item?.watchlist_count
                                            : 0}{' '}
                                        watchers | {item?.most_viewed || 25} viewers
                                    </div>
                                )}
                                {(item.market_status === 'open' && item.auction) ||
                                item.market_status === 'open' ? (
                                    <Timer
                                        date_added={item.date_added}
                                        date_closed={item.date_closed}
                                        withText={1}
                                        endText={' '}
                                        startText={' '}
                                        theme="gFThemeTimer"
                                        iconGrid={false}
                                        audio={props.audio}
                                    />
                                ) : (
                                    <>
                                        {item.buynow === 0 ? (
                                            <div className="closedText text-center d-block minHeight">
                                                Auction Closed
                                            </div>
                                        ) : (
                                            <div className="closedText text-center d-block"></div>
                                        )}
                                    </>
                                )}
                                {watchlist && (
                                    <div
                                        className={`homeflashBtnGroup ml-auto mr-auto mt-2 ${
                                            !isAuthenticated && 'noAuth'
                                        } ${item.auction !== item.buynow ? 'singleBtnBox' : ''}`}
                                    >
                                        {item.auction && !item.buynow ? (
                                            <>
                                                {isAuthenticated ? (
                                                    <PrimaryButton
                                                        btnSize="homeBidBtn"
                                                        disabled={item.market_status == 'sold'}
                                                        onClick={() => handleBidModalClick(item.id)}
                                                        label="Bid Now"
                                                    />
                                                ) : (
                                                    <PrimaryButton
                                                        btnSize="homeBidBtn"
                                                        disabled={item.market_status == 'sold'}
                                                        onClick={() =>
                                                            handleRedirectInternal(history, 'login')
                                                        }
                                                        label="Login To Bid"
                                                    />
                                                )}
                                            </>
                                        ) : item.auction && item.buynow ? (
                                            <>
                                                {isAuthenticated ? (
                                                    <>
                                                        <PrimaryButton
                                                            btnSize="homeBidBtn"
                                                            disabled={item.market_status == 'sold'}
                                                            onClick={() =>
                                                                handleBidModalClick(item.id)
                                                            }
                                                            label="Bid Now"
                                                        />
                                                        <PrimaryButton
                                                            btnSize="homeBuyBtn"
                                                            disabled={item.market_status == 'sold'}
                                                            name={item.id}
                                                            onClick={() => handleCart(item.id)}
                                                            label={
                                                                window.location.pathname.includes(
                                                                    'search',
                                                                ) ||
                                                                props.type === 'Auction' ||
                                                                item.auction
                                                                    ? (props.type === 'buynow' ||
                                                                          item.buynow) &&
                                                                      (!item.auction ||
                                                                          window.location.href.includes(
                                                                              '/gallery',
                                                                          ))
                                                                        ? isAuthenticated
                                                                            ? 'Buy Now'
                                                                            : 'Login To Buy Now'
                                                                        : isAuthenticated
                                                                        ? 'Buy Now'
                                                                        : 'Login To Bid'
                                                                    : isAuthenticated
                                                                    ? 'Buy Now'
                                                                    : 'Login To Buy Now'
                                                            }
                                                            btnColor={
                                                                item.latestbid_user == user?.id &&
                                                                'success'
                                                            }
                                                        />
                                                    </>
                                                ) : (
                                                    <PrimaryButton
                                                        btnSize="homeBidBtn"
                                                        disabled={item.market_status == 'sold'}
                                                        onClick={() =>
                                                            handleRedirectInternal(history, 'login')
                                                        }
                                                        label="Login To Bid"
                                                    />
                                                )}
                                            </>
                                        ) : !item.auction && item.buynow ? (
                                            <>
                                                {isAuthenticated ? (
                                                    <>
                                                        <div className="opacity-0"></div>
                                                        <PrimaryButton
                                                            btnSize="homeBuyBtn"
                                                            disabled={item.market_status == 'sold'}
                                                            name={item.id}
                                                            onClick={() => handleCart(item.id)}
                                                            label={
                                                                window.location.pathname.includes(
                                                                    'search',
                                                                ) ||
                                                                type === 'Auction' ||
                                                                item.auction
                                                                    ? (type === 'buynow' ||
                                                                          item.buynow) &&
                                                                      (!item.auction ||
                                                                          window.location.href.includes(
                                                                              '/gallery',
                                                                          ))
                                                                        ? isAuthenticated
                                                                            ? 'Buy Now'
                                                                            : 'Login To Buy Now'
                                                                        : isAuthenticated
                                                                        ? bidText
                                                                        : 'Login To Bid'
                                                                    : isAuthenticated
                                                                    ? 'Buy Now'
                                                                    : 'Login To Buy Now'
                                                            }
                                                            btnColor={
                                                                item.latestbid_user == user?.id &&
                                                                'success'
                                                            }
                                                        />
                                                    </>
                                                ) : (
                                                    <PrimaryButton
                                                        btnSize="homeBuyBtn"
                                                        disabled={item.market_status == 'sold'}
                                                        onClick={() =>
                                                            handleRedirectInternal(history, 'login')
                                                        }
                                                        label="Login To Buy"
                                                    />
                                                )}
                                            </>
                                        ) : (
                                            ''
                                        )}
                                    </div>
                                )}
                            </div>
                            {/* <div className="alert">
                                You have 3 days
                                following
                                auction close to
                                pick up. LAST
                                DAY TO PICK UP
                                IS [Dynamic Day
                                Month Numeric
                                Day]!!
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default RetailListView
